export default class BzAdPage {
    constructor() {
        this.init();
    }

    init() {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        var observer = new MutationObserver(function(mutations) {
            if ($('.bz-custom-container').length) {
                // bss wl, tributes wl, bss standalone, mytributes standalone
                var $elementWrapper = $("body .bss, body .tributes, .buysearchsell body, .mytributes body");
                if ($elementWrapper.length) {
                    $elementWrapper.addClass('bz-page-wrapper');
                    observer.disconnect();
                }
             }
         });
        observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree:true });
        // Stop looking for the class in the dom after 20 seconds
        setTimeout(function() {
            observer.disconnect();
        }, 20000);
    }
}